<template>
    <div class="animated fadeIn">
  
      
      <b-card class="card-accent-info" header="Lista de Peças">
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
                <!--
                <b-form-group>
                    <b-button v-show="false" variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                    &nbsp;
                    <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
              </b-form-group>
              -->
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Nova Peça</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="name">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"  v-on:keyup.enter="filterChanged"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.summary && row.item.summary.length > 0">
                            <b-col class="small">Resumo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.summary }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.content && row.item.content.length > 0">
                            <b-col class="small">Conteúdo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col>{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                        </b-row>
                    </b-card>
                </template>
                
                <template v-slot:cell(st)="data">
                    <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(name)="data">
                    <div>
                    {{ data.item.name }}
                    </div>
                </template>
                
                  
                <template v-slot:cell(icon)="data">
                    <img :src="data.item.icon ? data.item.icon : 'img/noimage.png'" class="circle-img rounded-circle" width="50" height="50" />
                </template>
  
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Peça"
              size="lg">
  
        <b-form @submit.stop.prevent="onSubmit">
  
        <div class="animated fadeIn">
      
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Id Peça"
                label-for="partId"
                :label-cols="3"
                :horizontal="true">
                <b-row>
                    <b-col cols="4">
                        <b-form-input v-model="selectedItem.partId" id="partId" type="text" :readonly="isUpdate"></b-form-input>
                    </b-col>
                </b-row>
                
              </b-form-group>          
              </b-form>
              </b-col>
          </b-row>

        
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Nome"
                label-for="name"
                :label-cols="3"
                :horizontal="true">
                <b-form-input v-model="selectedItem.name" id="name" type="text"></b-form-input>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Nome QAD"
                label-for="alias"
                :label-cols="3"
                :horizontal="true">
                
                        <b-form-input v-model="selectedItem.alias" id="alias" type="text"></b-form-input>
               
              </b-form-group>          
              </b-form>
              </b-col>
          </b-row>
  
          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="U/M"
                label-for="unit"
                :label-cols="3"
                :horizontal="true">
                <b-row>
                    <b-col cols="4">
                      <b-form-select id="unit"
                        v-model="selectedItem.unit"
                        :plain="true"
                        :options="[
                          { 'value': 'KG', 'text': 'KG' },
                          { 'value': 'L', 'text': 'L' },
                          { 'value': 'M', 'text': 'M' },
                          { 'value': 'PC', 'text': 'PC' },
                          { 'value': 'UM', 'text': 'UM' }
                        ]"
                        value="">
                      </b-form-select>
                    </b-col>
                  </b-row>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Verificado"
                label-for="checked"
                :label-cols="3"
                :horizontal="true">
                <b-row>
                  <b-col cols="4">
                  <b-form-select id="checked"
                    v-model="selectedItem.checked"
                    :plain="true"
                    :options="[
                      { 'value': 'S', 'text': 'SIM' },
                      { 'value': 'N', 'text': 'NAO' }
                    ]"
                    value="">
                  </b-form-select>
                </b-col>
                </b-row>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="12">
              
              <b-form>
                <b-form-group
                description=""
                label="Mult"
                label-for="mult"
                :label-cols="3"
                :horizontal="true">
                <b-row>
                    <b-col cols="4">
                      <b-form-input v-model="selectedItem.mult" id="mult" type="text"></b-form-input>
                    </b-col>
                </b-row>
              </b-form-group>          
              </b-form>
            </b-col>
          </b-row>

          
          <b-row>
              <b-col md="12">
                <b-form>
                  <b-form-group
                  description=""
                  label="Quantidade"
                  label-for="batchQuantity"
                  :label-cols="3"
                  :horizontal="true">
                  <div>
                    <b-row>
                     <b-col cols="4"><b-form-input v-model="selectedItem.batchQuantity" id="batchQuantity" type="number"></b-form-input></b-col>
                      <b-col></b-col>
                    </b-row>
                    
                  </div>
                </b-form-group>          
                </b-form>
              </b-col>
            </b-row>


  
          <b-input-group class="mb-4">
              <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
          </b-input-group>
        
          <div slot="footer" class="text-right">
            <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
            <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
            <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Peça</span></b-button>
           
          </div>
                
        </div>
        </b-form>
  
      </b-modal>
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios";
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: '', name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch
    },
    data: () => {
      return {
        isUpdate: false,
        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        editModal: false,
        filters: {
          key: ''
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "100px" } },
          {key: 'partId', label: 'Id Peça', sortable: true, thStyle: { width: "120px" }, tdClass: 'align-middle'  },
          //{key: 'childId', label: 'Filho', sortable: true, thStyle: { width: "120px" }, tdClass: 'align-middle'  },
          //{key: 'name', label: 'Nome', sortable: true },
          //{key: 'icon', label: "", thStyle: { width: "60px" }, tdClass: 'align-middle' },
          {key: 'name', label: 'Nome', sortable: true },
          {key: 'alias', label: 'Nome QAD', sortable: true },
          {key: 'unit', label: 'Unidade', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          {key: 'checked', label: 'Verificado', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          {key: 'mult', label: 'Mult', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          {key: 'batchQuantity', label: 'Lote', sortable: true, thStyle: { width: "100px" }, tdClass: 'align-middle' },
          //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
          //{key: 'createdIn', label: 'Data', sortable: true, thStyle: { width: "140px" } },
          //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {
            return this.items.filter(item => {
              return this.filters.key == '' 
              || this.$utils.filterString(item.name, this.filters.key)
              || this.$utils.filterString(item.partId, this.filters.key)
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {
      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     
      async save() {

        var s = this;
        if(this.selectedItem.partId && this.selectedItem.partId.length > 0
          && this.selectedItem.name && this.selectedItem.name.length > 0
          ) {

            this.selectedItem.uid = s.$store.state.currentUser.id
            this.selectedItem.sid = s.$store.state.currentUser.sid

            console.log(this.selectedItem)
            try {
              if(this.isUpdate) {
                await axios.patch(
                    this.$store.state.ws_url + "/rastrea/aptiv/part",
                    this.selectedItem
                    
                )
                .then(function(resp) {
                  s.closeEditModal()
                  s.refreshData();
                })
                .catch(function (error) {
                  console.log(error);
                });
              
              }
              else {
                await axios.post(
                    this.$store.state.ws_url + "/rastrea/aptiv/part",
                    this.selectedItem
                )
                .then(function(resp) {
                  s.closeEditModal()
                  s.refreshData();
                })
                .catch(function (error) {
                  console.log(error);
                });
              }
          
            }
            catch(err) {
              toast ({
                    type: VueNotifications.types.error,
                    title: 'Item',
                    message: 'Item já cadastrado',
                    timeout: 3000
                  })

            }
        }
        else {
          toast ({
                type: VueNotifications.types.error,
                title: 'Item',
                message: 'Preencha os campos obrigatórios: Código pai, código filho e nome.',
                timeout: 5000
              })
        }


        },
      enableDisable() {
        console.log('Habilitando/desabilitando sentimento')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.isUpdate = false;
            this.selectedItem = { ...newItem} ;      
        }
        else {
            this.isUpdate = true;
            this.selectedItem = { ...item };
        }
        this.editModal = true;
      },
      onRowSelected(items) {
        this.selected = items
        //console.log(items);
        //this.openEditModal(items[0])
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },
      toggleBusy() {
        this.isBusy = !this.isBusy
      },
      filterChanged() {
        if(this.filters.key && this.filters.key.length >= 4)
        this.refreshData();
      },
      async refreshData() {
           
          var s = this;
          var currentUser = this.$store.state.currentUser;
      
          //console.log(this.$store.state.ws_url + "/rastrea/aptiv/part?key=" + s.filters.key + "&currentUserId=" + currentUser.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid)

          await axios.get(
            this.$store.state.ws_url + "/rastrea/aptiv/part?key=" + s.filters.key + "&currentUserId=" + currentUser.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).catch(function(resp) {
            s.items =  s.$utils.mergeArrays(s.items, resp.data.obj, 'partId')
          })
          
          this.isBusy = false;
       
      }
    },
    mounted: function() {
      this.isBusy = true;
      this.refreshData();
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>